import type { CheckboxSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import type { ElementStyleCss } from 'services/Branding/types'

const DragIconStyled = styled.div<{
  $active?: boolean
  $style: ElementStyleCss<CheckboxSchemaType>
}>`
  position: absolute;
  display: none;
  width: 16px;
  height: 24px;
  top: 50%;
  right: 4px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  box-shadow: var(--box-shadow-default);
  background-color: var(--color-background-main);
  transform: translateY(-50%);
`

export default DragIconStyled
